import {
    Button,
    Container,
    Stack
} from '@mui/material';
import UpdatePasswordForm from 'components/UpdatePasswordForm';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAccount } from 'slices/accountActions';
import { useAppDispatch } from 'utilities/hooks';

const PasswordUpdatePage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchAccount());
    }, []);

    return <>
        <Container component="main" maxWidth="xs">
            <Stack spacing={5} sx={{ mt: 3 }}>
                <UpdatePasswordForm />
                <Button
                    onClick={() => {
                        navigate('/profile');
                    }}
                    fullWidth
                    variant="outlined"
                    size="large"
                    disableElevation
                    sx={{ mt: 3, mb: 3 }}
                >
                    Back
                </Button>
            </Stack>
        </Container>
    </>;
};

export default PasswordUpdatePage;